<template>
  <div class="loading-view">
    <div class="loading-container">
      <div class="logo-loader">
        <div class="logo-base" :style="logoStyle"></div>
        <div class="logo-fill" :style="logoStyle"></div>
      </div>
      <h2>{{ title }}</h2>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script setup>
import logoUrl from '@/assets/images/logo/logo.png'

defineProps({
  title: {
    type: String,
    default: '加載中'
  },
  message: {
    type: String,
    default: '正在初始化，請稍候...'
  }
})

const logoStyle = {
  backgroundImage: `url(${logoUrl})`
}
</script>

<style scoped>
.loading-view {
  position: fixed;  /* 固定定位 */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.8);  /* 半透明黑色遮罩 */
  z-index: 9999;  /* 確保在最上層 */
}

.loading-container {
  text-align: center;
  color: #79c3c8;
}

.loading-container h2 {
  margin: 16px 0 8px;
  font-size: 18px;
}

.loading-container p {
  margin: 0;
  font-size: 14px;
  color: #FFFFFF;
}

.logo-loader {
  position: relative;
  width: 140px;
  height: 60px;
  margin: 0 auto;
}

.logo-base,
.logo-fill {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}

.logo-base {
  filter: grayscale(100%) brightness(0.6);
  opacity: 0.6;
}

.logo-fill {
  clip-path: inset(100% 0 0 0);
  animation: logo-fill-up 1.8s ease-in-out infinite;
}

@keyframes logo-fill-up {
  0% { clip-path: inset(100% 0 0 0); }
  45% { clip-path: inset(0% 0 0 0); }
  80% { clip-path: inset(0% 0 0 0); }
  100% { clip-path: inset(100% 0 0 0); }
}
</style>